<template>
<div class="w-80 ma-auto">
  <v-row class="grid image-grid">
    <v-col cols="12" xl="6" lg="6" md="12" sm="12">
      <v-row>
        <v-col class="d-flex flex-column justify-center align-center" cols="12" xl="6" lg="6" md="12" sm="12">
          <div class="grid-block">
            <div class="tile">
              <a style="position: relative" class="tile-link" href="#">
                <p class="tile-img font-weight-bold white--text" style="position: absolute;
         text-shadow: rgb(11 70 226 / 70%) 0px 2px 0px;
           top: 60%;
           right: 9%;
           z-index: 11;
           opacity: 0;

">
                  بزرگ‌ترین خط تولید شیشه فلوت   </p>
                <img class="tile-img tile-img2" src="../../../../assets/images/product-images/float-glass.jpg" alt="Image">
              </a>
            </div>
          </div>
        </v-col>
        <v-col class="d-flex flex-column justify-center align-center" cols="12" xl="6" lg="6" md="12" sm="12">
          <div class="grid-block">
            <div class="tile">
              <a style="position: relative" class="tile-link" href="#">
                <p class="tile-img font-weight-bold white--text" style="position: absolute;
         text-shadow: rgb(11 70 226 / 70%) 0px 2px 0px;
           top: 60%;
           right: 9%;
           z-index: 11;
           opacity: 0;

">
                  تولید انواع ماسه سیلیس ریخته گری</p>
                <img class="tile-img tile-img3" src="../../../../assets/images/product-images/masse.jpg" alt="Image">
              </a>
            </div>
          </div>
        </v-col>
      </v-row>
      <div class="grid-block">
        <div class="tile">
          <a style="position: relative" class="tile-link" href="#">
            <p class="tile-img font-weight-bold white--text" style="position: absolute;
         text-shadow: rgb(11 70 226 / 70%) 0px 2px 0px;
           top: 77%;
           right: 5%;
           z-index: 11;
           opacity: 0;

">
              تولید کربنات سدیم با کیفیت برای استفاده در صنایع مختلف مانند شیشه، نفت، گاز و تصفیه آب</p>
            <img class="tile-img tile-img1" src="../../../../assets/images/product-images/karbonat-sodium.jpg" alt="Image">
          </a>
        </div>
      </div>
    </v-col>
    <v-col class="d-flex align-center justify-center"  cols="12" xl="6" lg="6" md="12" sm="12">
      <div style="height: 100%" class="grid-block d-flex align-center justify-center">
        <div style="height: inherit" class="tile d-flex align-center justify-center">
          <a style="position: relative" class="tile-link" href="#">
           <h5 class="tile-img font-weight-bold white--text" style="position: absolute;
         text-shadow: rgb(11 70 226 / 70%) 0px 2px 0px;
           top: 87%;
           right: 4%;
           z-index: 11;
           opacity: 0;

">
             بزرگ‌ترین مجموعه پروسسینگ شیشه در غرب آسیا برای تولید انواع شیشه‌های ساختمانی و صنعتی</h5>
            <img  style="height: fit-content !important;" class="tile-img tile-img10" src="../../../../assets/images/product-images/architucture-glass.jpg" alt="Image">
          </a>
        </div>
      </div>
    </v-col>
  </v-row>
</div>
</template>
<script>
export default {
  name: 'ProductsGrid',
  data(){
    return{
      show:false
    }
  }
}
</script>
<style scoped>

html {
  box-sizing: border-box;
}

*,
*:before,
*:after {
  box-sizing: inherit;
}

body {
  margin: 0;
  min-height: 100vh;
  font-size: 1rem;
  line-height: 1.25;
  background-color: #18222d;
}

.grid {
  width: 100%;
  margin-left: auto;
  margin-right: auto;

  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  flex-direction: row;
  flex-wrap: wrap;
}

.grid-block {
  min-height: 11.25rem;
  padding: 1rem;
}

.image-grid {

  -webkit-perspective: 1000px;
  perspective: 1000px;
}

.image-grid .tile-link:hover .tile-img {

  top: -1rem;
  left: -1rem;
}

.image-grid .tile-img {
  position: relative;
  top: 0;
  left: 0;
  -webkit-transition-property: opacity, top, left, box-shadow;
  transition-property: opacity, top, left, box-shadow;
}

.tile-link {
  display: block;
}

.tile-link:hover .tile-img  {
  opacity: 1 !important;
}

.tile-link:hover .tile-img-link {
  display: block;
}

.tile-link:hover .tile-img-link:hover .tile-img {
  opacity: 0.5;
}

.tile-img {
  display: block;
  width: 100%;
  height: auto;
  opacity: 1;
  -webkit-transition-property: opacity;
  transition-property: opacity;
  -webkit-transition-duration: 0.125s;
  transition-duration: 0.125s;
  -webkit-transition-timing-function: ease-in;
  transition-timing-function: ease-in;
}
.tile-link:hover .tile-img1 {

  box-shadow: 5px 5px rgba(244, 170, 200, 0.4),
  10px 10px rgba(244, 170, 200, 0.3), 15px 15px rgba(244, 170, 200, 0.2),
  20px 20px rgba(244, 170, 200, 0.1), 25px 25px rgba(244, 170, 200, 0.05);
}

.tile-link:hover .tile-img2 {
  box-shadow: 5px 5px rgba(45, 186, 233, 0.4), 10px 10px rgba(45, 186, 233, 0.3),
  15px 15px rgba(45, 186, 233, 0.2), 20px 20px rgba(45, 186, 233, 0.1),
  25px 25px rgba(45, 186, 233, 0.05);
}

.tile-link:hover .tile-img3 {
  box-shadow: 5px 5px rgba(244, 170, 200, 0.4),
  10px 10px rgba(244, 170, 200, 0.3), 15px 15px rgba(244, 170, 200, 0.2),
  20px 20px rgba(244, 170, 200, 0.1), 25px 25px rgba(244, 170, 200, 0.05);
}


.tile-link:hover .tile-img10 {
  opacity: 1;

  box-shadow: 5px 5px rgba(4, 140, 231, 0.4), 10px 10px rgba(4, 140, 231, 0.3),
  15px 15px rgba(4, 140, 231, 0.2), 20px 20px rgba(4, 140, 231, 0.1),
  25px 25px rgba(4, 140, 231, 0.05);
}

</style>
